import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";
import { Col, Container, Row } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { useSiteConfig } from "../../context/SiteConfigContext";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState({});
  const [metaData, setMetaData] = useState({});
  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const params = {
        limit: 4,
      };

      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;

        setItem(blog);
        setRelatedBlogs(relatedBlogs);
        setMetaData(blog?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  const getInitials = (name) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase(); // e.g. "Sohan" → SO
    }

    return (words[0][0] + words[words.length - 1][0]).toUpperCase(); // e.g. "Sohan Kumar" → SK
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.title} middle="" />
      <SEO meta={metaData} />

      <div className="premium-detail-page">
        {/* SECTION 1: ASYMMETRIC HERO */}
        <section className="hero-split d-flex align-items-center">
          <div className="hero-text-side">
            <div className="content-inner">
              <span className="category-label-top">The Heritage Series</span>
              <h1 className="main-display-title">{item?.title}</h1>
              <p className="intro-subtitle">{item?.shortDescription}</p>
              <div className="author-info-box">
                <div className="blog-badge-circle">
                  {getInitials(item?.author)}
                </div>

                <div>
                  <h6>{item?.author}</h6>
                  <span>{formatDate(item?.date)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-image-side">
            <img src={item?.image} alt="Jewelry" />
          </div>
        </section>

        {/* SECTION 2: EDITORIAL CONTENT */}
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col lg={2} className="d-none d-lg-block">
              <div className="sticky-socials">
                <span>Connect</span>
                <div className="line"></div>
                {config?.socialMedia?.facebook && (
                  <li>
                    <a
                      href={config?.socialMedia?.facebook}
                      target="_blank"
                      className="social-icon"
                    >
                      <FaFacebook size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.instagram && (
                  <li>
                    <a
                      href={config?.socialMedia?.instagram}
                      target="_blank"
                      className="social-icon"
                    >
                      <FaInstagram size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.twitter && (
                  <li>
                    <a
                      href={config?.socialMedia?.twitter}
                      target="_blank"
                      className="social-icon"
                    >
                      <FaTwitter size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.youtube && (
                  <li>
                    <a
                      href={config?.socialMedia?.youtube}
                      target="_blank"
                      className="social-icon"
                    >
                      <FaYoutube size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.linkedin && (
                  <li>
                    <a
                      href={config?.socialMedia?.linkedin}
                      target="_blank"
                      className="social-icon"
                    >
                      <FaLinkedin size={16} />
                    </a>
                  </li>
                )}
              </div>
            </Col>

            <Col lg={7} className="article-body">
              <div className="drop-cap-wrapper">
                <div dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>

              {relatedBlogs && relatedBlogs.length > 0 && (
                <div className="row g-2 py-3">
                  <h2 className="section-title">Related Blogs</h2>
                  {relatedBlogs.map((blog, index) => (
                    <div key={blog._id || index} className="col-md-12">
                      <BlogRelatedCard item={blog} />
                    </div>
                  ))}
                </div>
              )}
           <div className="d-flex justify-content-center mt-3">
             <Link to='/blog' className="view-all-blog">View All</Link>
           </div>

            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
}

export default DetailPage;
